// @spec DHB-STR-033
// Period comparison route

import { createFileRoute } from '@tanstack/react-router';

import { PeriodComparisonPage } from '@/features/datahub/components/PeriodComparisonPage';

export const Route = createFileRoute('/_authenticated/datahub/comparison')({
  component: PeriodComparisonPage,
  validateSearch: (search: Record<string, unknown>) => ({
    periodIds: typeof search.periodIds === 'string' ? search.periodIds : undefined,
    category: typeof search.category === 'string' ? search.category : undefined,
    threshold: typeof search.threshold === 'number' ? search.threshold : undefined,
    includeEmpty: search.includeEmpty === 'true' || search.includeEmpty === true,
    page: typeof search.page === 'number' ? search.page : undefined,
    pageSize: typeof search.pageSize === 'number' ? search.pageSize : undefined,
  }),
});
